import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { RolesService } from "../../services/RolesService";
import { Controller } from "../../models/Controller";
import { View } from "../../models/View";
import {
  ENDPOINTS_COLORS,
  ROLE_CONSTANTS
} from "../../constants/RoleConstants";
import { Http } from "@status/codes";
import { Role } from "../../models/Role";
import { Utils } from "@/shared/utils/utils";
import SidePanelPermissionCard from "./../SidePanelPermissionCard/SidePanelPermissionCard.vue";
import AdminRolCard from "./../AdminRolCard/AdminRolCard.vue";
import LandingCard from "./../LandingCard/LandingCard.vue";
import PermissionCard from "./../PermissionCard/PermissionCard.vue";
import AssignPermissionCard from "./../AssignPermissionCard/AssignPermissionCard.vue";
import { ReferenceDataAccess } from "./../../models/ReferenceData";
import { InitialData } from "../../models/InitialData";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { ROLES_ACCESS } from "../../constants/RoleConstants";

@Component({
  name: "SaveRole",
  components: {
    ModalTemplate,
    AdminRolCard,
    PermissionCard,
    LandingCard,
    AssignPermissionCard,
    SidePanelPermissionCard
  }
})
export default class SaveRole extends Vue {
  @Inject() rolesService!: RolesService;

  @Prop() idRole!: string;
  @Prop({ default: false, required: false })
  public isModal!: boolean;

  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  btnRoundClassPrimary = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  switchClass = STYLE_CLASSES.SWITCH;
  cardClass = STYLE_CLASSES.CARD;

  SELECTED_CHIP = STYLE_CLASSES.CHIP_COLOR.ACCENT;
  PAGE_TITLE = ROLE_CONSTANTS.PAGE_TITLE_CREATE;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  CANCEL = FORM_CONSTANTS.BUTTON.CANCEL;
  ENDPOINTS_TEXT = ROLE_CONSTANTS.ENDPOINTS_TEXT;
  VIEWS_ALLOWED = ROLE_CONSTANTS.VIEWS_ALLOWED_TEXT;
  ADD_TEXT = ROLE_CONSTANTS.ADD_ENDPOINT;
  ADD_VIEW = ROLE_CONSTANTS.ADD_VIEW;
  ROLE_NAME_TEXT = ROLE_CONSTANTS.ROLE_NAME;
  ACTIVE_TEXT = FORM_CONSTANTS.LABEL.STATE;
  SERVICE_TEXT = ROLE_CONSTANTS.SERVICE_TEXT;
  VIEWS_TEXT = ROLE_CONSTANTS.VIEWS;
  PAGE_START = FORM_CONSTANTS.BUTTON.PAGE_START;
  COLORS = ENDPOINTS_COLORS;
  PERMISSION = ROLE_CONSTANTS.PERMISSION_TEXT;

  rules = {
    name: [FORM_VALIDATORS.REQUIRED_FIELD, FORM_VALIDATORS.NOT_BLANK_SPACES]
  };

  dialog = false;
  isEditing = false;
  state = true;
  updatedControllers = false;
  modalText = "";
  modalTitle = "";
  roleName = "";
  controllerSelected = "";
  viewSelected = "";
  roleRef = "";
  controllers: string[] = [];
  currentAccess: string[] = [];
  accessViews: string[] = [];
  showAccess: string[] = [];
  sendEndpoint: string[] = [];
  views: View[] = [];

  referenceDataAccess: ReferenceDataAccess = {
    side: [] as View[],
    principalList: new Set<string>() as Set<string>,
    views: [] as View[],
    viewCurrent: ""
  };
  currentData: InitialData = { viewsList: [], controllersList: [] };
  currentEndpoints: { controller: string; ids: string[] }[] = [];
  isValidName = false;

  async mounted() {
    if (!this.isModal) {
      this.goToInit();
    }
    if (!this.isModal && (this.$route.params.id || this.idRole)) {
      this.roleRef = this.$route.params.id || this.idRole;
      await this.getRoleData(this.roleRef);
    }

    await this.initialData();
  }

  goToInit() {
    this.goToStart(ROLE_CONSTANTS.ID_REF_GO_TO);
  }

  @Watch("idRole")
  async changeIdRole() {
    this.roleRef = this.idRole;
    await this.getRoleData(this.roleRef);
    this.updateCurrentData();
  }

  updateCurrentData() {
    this.referenceDataAccess.viewCurrent = "";
    if (!this.idRole) {
      this.currentData = { viewsList: [], controllersList: [] };
      return;
    }
    const viewsList: View[] = [];

    const fintionUpdateView = (view: View) => {
      if (this.accessViews.includes(view.id)) {
        view.actived = true;
        view.show = true;
        viewsList.push({ ...view });
      } else {
        view.actived = false;
        view.show = false;
      }
    };
    this.referenceDataAccess.side.forEach(fintionUpdateView);
    this.referenceDataAccess.views.forEach(fintionUpdateView);
    this.referenceDataAccess.principal?.forEach(fintionUpdateView);
    const controllersList: Controller[] = [];
    const existController = (controllerName: string): boolean => {
      if (this.currentAccess.length == 0) {
        return false;
      }
      const index = this.currentAccess.findIndex(
        name => name == controllerName
      );
      if (index == -1) {
        return false;
      }
      return true;
    };

    this.referenceDataAccess.controller?.forEach(controller => {
      let exist = false;
      const newController = { ...controller };
      if (!existController(newController.allId)) {
        newController.allId = "";
        if (!existController(newController.getId)) {
          newController.getId = "";
        } else {
          exist = true;
        }
        if (!existController(newController.postId)) {
          newController.postId = "";
        } else {
          exist = true;
        }
        if (!existController(newController.putId)) {
          newController.putId = "";
        } else {
          exist = true;
        }
        if (!existController(newController.deleteId)) {
          newController.deleteId = "";
        } else {
          exist = true;
        }
      } else {
        exist = true;
      }
      if (exist) {
        controllersList.push({ ...newController });
      }
    });

    this.currentData = { viewsList, controllersList };
  }

  async initialData() {
    try {
      const responseData = await this.rolesService.getInitialData();

      if (responseData.code === Http.Found && responseData.data) {
        this.views = responseData.data.viewsList;
        const list = this.views.reduce((prevViews, view) => {
          view = { actived: false, show: false, ...view };
          if (view.isInContexPanel) {
            prevViews.side?.push(view);
          } else {
            prevViews.views?.push(view);
          }
          if (view.parentView != "") {
            prevViews.principalList?.add(view.parentView);
          }
          return prevViews;
        }, this.referenceDataAccess);

        list.side.sort(
          (view1, view2) => (view1.order ?? 0) - (view2.order ?? 0)
        );
        list.controller = responseData.data.controllersList;
        list.principal = Array.from(list.principalList).map(
          (parentView: string): View => {
            const index = list.views.findIndex(
              viewFind => viewFind.id == parentView
            );
            const viewNew = list.views[index];
            list.views.splice(index, 1);
            return viewNew as View;
          }
        );
        this.referenceDataAccess = list;
        this.updateCurrentData();
        return;
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getRoleData(id: string) {
    try {
      const role = await this.rolesService.getRoleData(id);
      if (role.code === Http.Found && role.data) {
        this.isEditing = true;
        this.accessViews = role.data.views;
        this.currentAccess = role.data.access;
        this.roleName = role.data.name;
        this.state = role.data.state;
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  convertData() {
    this.sendEndpoint = [];
    this.accessViews = [];

    this.accessViews = this.currentData.viewsList.map(view => view.id);

    this.currentData.controllersList.forEach(controller => {
      if (controller.allId) {
        this.sendEndpoint.push(controller.allId);
        return;
      }
      if (controller.getId) {
        this.sendEndpoint.push(controller.getId);
      }
      if (controller.postId) {
        this.sendEndpoint.push(controller.postId);
      }
      if (controller.putId) {
        this.sendEndpoint.push(controller.putId);
      }
      if (controller.deleteId) {
        this.sendEndpoint.push(controller.deleteId);
      }
    });

    const role: Role = {
      name: this.roleName.trim(),
      access: this.sendEndpoint,
      views: this.accessViews,
      state: this.state
    };
    const user = localStorage.getItem(FORM_CONSTANTS.UID_TEXT);

    if (this.roleRef === "" && user) {
      role.createdBy = user;
    } else if (user) {
      role.changedBy = user;
    }
    return role;
  }

  checkSave() {
    if (this.isEditing) {
      this.modalTitle = ROLE_CONSTANTS.UPDATE_MODAL.TITLE;
      this.modalText = ROLE_CONSTANTS.UPDATE_MODAL.TEXT;
    } else {
      this.modalTitle = FORM_MESSAGES.SAVE_MODAL.TITLE;
      this.modalText = FORM_MESSAGES.SAVE_MODAL.MESSAGE;
    }
    this.dialog = true;
  }

  async save() {
    const role = this.convertData();
    try {
      const result = await this.rolesService.createRole(role);

      if (result.code === Http.Ok) {
        Snackbar.popSuccess(ROLE_CONSTANTS.MESSAGES.ROLE_CREATED);
        this.showAccess = [];
        this.currentEndpoints = [];
        this.roleName = "";
        this.state = false;
        this.onClose(role.name);
      } else if (result.code === Http.InternalServerError) {
        Snackbar.popInfo(ROLE_CONSTANTS.MESSAGES.ROLE_ALREADY_EXIST);
      } else {
        Snackbar.popError(result.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async update() {
    try {
      const role = this.convertData();
      const result = await this.rolesService.updateRole(role, this.roleRef);

      if (result.code === Http.Ok) {
        Snackbar.popSuccess(ROLE_CONSTANTS.MESSAGES.ROLE_UPDATED);
        this.onClose();
      } else {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${ROLES_ACCESS.PUT}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  onClose(roleName?: string) {
    const createNameRole = true;
    roleName
      ? this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE, roleName, createNameRole)
      : this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE);
  }

  onCloseModal() {
    this.$emit(FORM_MESSAGES.EVENT_BUTTON.CLOSE_MODAL);
  }

  async handleModalAccept() {
    this.dialog = false;
    switch (this.modalTitle) {
      case ROLE_CONSTANTS.UPDATE_MODAL.TITLE:
        await this.update();
        break;
      case FORM_MESSAGES.SAVE_MODAL.TITLE:
        await this.save();
        break;
      default:
        break;
    }
  }

  handleModalCancel() {
    this.dialog = false;
  }

  goToStart(id: string) {
    Utils.scrollToElement(id, this);
  }

  get validRole() {
    if (
      this.roleName.trim().length > 0 &&
      this.currentData.viewsList.length > 0 &&
      this.isValidName &&
      this.updatedControllers
    ) {
      return true;
    }
    return false;
  }

  listViews(isSide: boolean): View[] {
    const viewTemp = isSide
      ? this.referenceDataAccess.side
      : this.referenceDataAccess.views;
    return viewTemp.filter(view => view.show) || [];
  }

  actionSelectViewList(id: string, isSide: boolean) {
    if (this.referenceDataAccess.viewCurrent) {
      Snackbar.popInfo(ROLE_CONSTANTS.MESSAGES.CLOSE_VIEW);
      return;
    }
    this.changeActivedView(id, isSide, true);
  }

  clearViewSelect() {
    const viewsList = this.currentData.viewsList.map(view => view.id);
    this.referenceDataAccess.side.forEach(view => {
      view.show = viewsList.includes(view.id);
    });

    this.referenceDataAccess.views.forEach(view => {
      view.show = viewsList.includes(view.id);
    });
    this.referenceDataAccess.principal?.forEach(view => {
      view.show = viewsList.includes(view.id);
    });
  }

  changeActivedView(id: string, isSide: boolean, state: boolean, save = false) {
    this.changeViewCurrent(id, state);
    if (isSide) {
      const index = this.referenceDataAccess.side.findIndex(
        view => view.id == id
      );
      this.referenceDataAccess.side[index].show = state;
      if (save) {
        this.referenceDataAccess.side[index].actived = state;
      }
      return;
    }
    const index = this.referenceDataAccess.views.findIndex(
      view => view.id == id
    );
    this.referenceDataAccess.views[index].show = state;
    if (save) {
      this.referenceDataAccess.views[index].actived = state;
    }

    this.changeActivedViewPrincipal(
      this.referenceDataAccess.views[index].parentView,
      state,
      save
    );
  }

  changeActivedViewPrincipal(id: string, state: boolean, save: boolean) {
    if (!this.referenceDataAccess.principal || !id) {
      return;
    }
    if (!state) {
      const index = this.referenceDataAccess.views.findIndex(
        view => view.show && view.parentView == id
      );
      if (index >= 0) {
        return;
      }
    }
    const index = this.referenceDataAccess.principal.findIndex(
      view => view.id == id
    );
    if (index == -1) {
      return;
    }
    this.referenceDataAccess.principal[index].show = state;

    if (save) {
      this.referenceDataAccess.principal[index].actived = state;
    }
  }

  changeViewCurrent(id: string, state = true) {
    if (!state && id == this.referenceDataAccess.viewCurrent) {
      this.referenceDataAccess.viewCurrent = "";
      return;
    }
    this.clearViewSelect();
    if (state) {
      this.referenceDataAccess.viewCurrent = id;
    }
  }

  DeleteCurrentData(
    viewBase: View,
    controllers: Controller[],
    isSide: boolean
  ) {
    this.changeActivedView(viewBase.id, isSide, false, true);
    const viewsList = this.changeView(viewBase, true);
    controllers = controllers.reduce((preController, otherController) => {
      const indexControllerUse = viewsList.findIndex(view =>
        view.controllers.includes(otherController.id)
      );
      if (indexControllerUse == -1) {
        preController.push(otherController);
      }
      return preController;
    }, [] as Controller[]);

    const controllersList = this.changeControllers(controllers, true);
    this.currentData = { viewsList, controllersList };
  }

  changeCurrentData(
    viewBase: View,
    controllers: Controller[],
    isSide: boolean
  ) {
    this.changeActivedView(viewBase.id, isSide, true, true);
    const viewsList = this.changeView(viewBase, false);
    const controllersList = this.changeControllers(controllers, false);
    this.currentData = { viewsList, controllersList };
  }

  changeView(viewBase: View, deleted: boolean): View[] {
    const viewsList = this.changeViewParent(
      [...this.currentData.viewsList],
      viewBase.parentView,
      deleted
    );
    const indexView = viewsList.findIndex(view => view.id == viewBase.id);
    if (deleted) {
      if (indexView >= 0) {
        viewsList.splice(indexView, 1);
      }
      return viewsList;
    }
    if (indexView == -1) {
      viewsList.push(viewBase);
    } else {
      viewsList[indexView] = viewBase;
    }
    return viewsList;
  }

  changeViewParent(viewsList: View[], idViewParent: string, deleted: boolean) {
    if (!idViewParent) {
      return viewsList;
    }
    let indexView = viewsList.findIndex(view => view.id == idViewParent);
    if (deleted) {
      indexView =
        viewsList.filter(view => view.parentView == idViewParent).length > 1
          ? -1
          : indexView;
      if (indexView >= 0) {
        viewsList.splice(indexView, 1);
      }
      return viewsList;
    }
    const viewBase = this.referenceDataAccess?.principal?.find(
      view => view.id == idViewParent
    );
    if (!viewBase) {
      return viewsList;
    }
    if (indexView == -1) {
      viewsList.push(viewBase);
    } else {
      viewsList[indexView] = viewBase;
    }
    return viewsList;
  }

  changeControllers(controllers: Controller[], deleted: boolean): Controller[] {
    const controllersList = [...this.currentData.controllersList];
    controllers.forEach(newController => {
      const indexController = controllersList.findIndex(
        controller => controller.id == newController.id
      );
      if (deleted) {
        if (indexController >= 0) {
          controllersList.splice(indexController, 1);
        }
        return;
      }
      if (indexController == -1) {
        controllersList.push(newController);
        return;
      }
      controllersList[indexController] = newController;
    });
    this.updatedControllers = true;
    return controllersList;
  }

  validNameField(value: boolean) {
    this.isValidName = value;
  }
}
